'use client';
import AppLayout from '@/components/AppLayout';
import DonationScreen from './components/DonationScreen';

export default function ApoieAPaginaPage() {
  return (
    <AppLayout>
      <DonationScreen />
    </AppLayout>
  );
}
